<template>
    <div class="scode-window"
         v-log="{
            event_type: 'show',
            event_name: '扫码绑定包厢-弹窗展示',
         }">
      <div class="scode-box" @click="handleClick">
        <img src="https://qncweb-back1.ktvsky.com/20240625/other/3f8d7e93ff20161e1fc53b2e291a4b39.png" >
      </div>
      <div class="close" @click.stop="closeBox">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="60" height="60" rx="30" fill="white" fill-opacity="0.4"/>
          <rect x="37.0711" y="20.1006" width="4" height="24" rx="2" transform="rotate(45 37.0711 20.1006)" fill="white"/>
          <rect x="39.8995" y="37.0713" width="4" height="24" rx="2" transform="rotate(135 39.8995 37.0713)" fill="white"/>
        </svg>
      </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import weixin from '@/libs/app/weixin.js';

export default {
  computed: {
    ...mapState({
      routerName() {
        return this.$route.path
      }
    })
  },
  watch: {
    routerName() {
      this.closeBox()
    }
  },
  methods: {
    closeBox() {
      this.$store.commit('SAVE_SHOW_SCODE_BOX', false);
    },
    handleClick() {
      this.$sendLog({
        event_type: 'click',
        event_name: '扫码绑定包厢-弹窗点击',
      });
      weixin.scanQRCode();
    },
  },
};
</script>

<style lang="scss" scoped>
.scode-window {
  background: #00000099;
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .scode-box {
    width: 690px;
    border-radius: 24px;
    padding: 30px;
    backdrop-filter: blur(5px);
  }
  .close {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 90px;
    right: 50px;
    svg {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
